import { render, staticRenderFns } from "./buySku.vue?vue&type=template&id=ef3c5ebc&scoped=true"
import script from "./buySku.vue?vue&type=script&lang=js"
export * from "./buySku.vue?vue&type=script&lang=js"
import style0 from "./buySku.vue?vue&type=style&index=0&id=ef3c5ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3c5ebc",
  null
  
)

export default component.exports